import { Mail, Phone, Globe, Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND, PRODUCTS } from "@/lib/products";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0b1e4d] text-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-14 md:py-20">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="inline-flex items-center bg-white rounded-2xl p-2 shadow-sm">
              <img
                src={BRAND.logo}
                alt="Beemamen"
                className="h-14 md:h-16 w-auto object-contain"
              />
            </div>
            <p className="font-hindi mt-4 text-lg text-[#f5b942] font-semibold">
              {BRAND.tagline_hi}
            </p>
            <p className="mt-3 text-sm text-slate-300 leading-relaxed max-w-md">
              India&apos;s trusted general insurance services partner — helping families, vehicle owners, farmers and businesses find the right cover at the right price.
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[Facebook, Instagram, Twitter, Linkedin].map((Ic, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-${i}`}
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#f5b942] hover:text-slate-900 flex items-center justify-center transition-colors"
                  aria-label="social"
                >
                  <Ic className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-bold text-base">Products</h4>
            <ul className="mt-4 space-y-2 text-sm text-slate-300">
              {PRODUCTS.map((p) => (
                <li key={p.slug}>
                  <a
                    href={`#products`}
                    data-testid={`footer-product-${p.slug}`}
                    className="hover:text-[#f5b942] transition-colors"
                  >
                    {p.title_en}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-bold text-base">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-300">
              {BRAND.phones.map((p) => (
                <li key={p} className="flex items-center gap-3">
                  <Phone className="w-4 h-4 text-[#f5b942] shrink-0" />
                  <a href={`tel:+91${p}`} className="hover:text-white">
                    +91 {p}
                  </a>
                </li>
              ))}
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#f5b942] shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-white">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Globe className="w-4 h-4 text-[#f5b942] shrink-0" />
                <a
                  href={`https://${BRAND.website}`}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white"
                >
                  {BRAND.website}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} {BRAND.legalName}. All rights reserved.</div>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <a href="#" className="hover:text-white">IRDAI Disclosures</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
